export default __webpack_public_path__ + "static/media/background.a8216cc5.jpg";